<!-- <span (click)="showPopover=true">
    <img src="../../../../assets/images/download-VOT.svg" matTooltip="Download" alt="Download" class="export-h-43 cursor">
  </span>
  <span *ngIf="showPopover">hi</span>
  <ng-container>
    <mat-menu #exportPop="matMenu" [hasBackdrop]="true" xPosition="before">
      <div class="drop-item-csv text-center cursor" (click)="rulExport('csv')">CSV
      </div>
      <div class="drop-item-json text-center cursor" (click)="rulExport('json')">JSON
      </div>
    </mat-menu>
  </ng-container> -->

  <!-- This button triggers the overlay and is it's origin -->
<span (click)="isOpen = !isOpen" type="button" cdkOverlayOrigin #trigger="cdkOverlayOrigin">
  <img src="../../../../assets/images/download-VOT.svg" matTooltip="Download" alt="Download" class="export-h-43 cursor">
</span>

<!-- This template displays the overlay content and is connected to the button -->
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen"
  [cdkConnectedOverlayHasBackdrop]="true"
  (backdropClick)="isOpen = false"
  [cdkConnectedOverlayPositions]="[
    {
      originX: 'start',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'top'
    },
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top'
    }
  ]"
  (detach)="isOpen = false"
>
  <ul class="example-list">
    <div class="drop-item-csv text-center cursor" (click)="rulExport('csv')">CSV
    </div>
    <div class="drop-item-json text-center cursor" (click)="rulExport('json')">JSON
    </div>
  </ul>
</ng-template>
